import { Col, FormGroup, Input, FormText } from 'reactstrap'


const FormGarantiaDetalleVehiculo = ( props ) => {
    // Se recuperan las props del componente
    const { 
        onInputChange,
        placa,
        color,
        modelo,
        marca,
    } = props

    return (
        <>
            <Col md={12}>
                <FormText>
                    <b>* Datos a Ingresar para Vehículo:</b>
                </FormText>
                <div className="border-bottom border-dark"></div>
                <div className="pt-3"></div>
            </Col>            
            <Col md={6}>
                <FormGroup>
                    <label htmlFor="placa">Placa:</label>
                    <Input 
                        id='placa' 
                        name='placa' 
                        value={ placa } 
                        onChange={ onInputChange } 
                        placeholder='Placa' 
                        type='text'/>
                </FormGroup>
            </Col>
            <Col md={6}>
                <FormGroup>
                    <label htmlFor="color">Color: </label>
                    <Input 
                        id='color' 
                        name='color' 
                        value={ color } 
                        onChange={ onInputChange } 
                        placeholder='Color' 
                        type='text'/>
                </FormGroup>
            </Col>
            <Col md={6}>
                <FormGroup>
                    <label htmlFor="modelo">Modelo: </label>
                    <Input 
                        id='modelo' 
                        name='modelo' 
                        value={ modelo } 
                        onChange={ onInputChange } 
                        placeholder='Modelo' 
                        type='text'/>
                </FormGroup>
            </Col>
            <Col md={6}>
                <FormGroup>
                    <label htmlFor="marca">Marca: </label>
                    <Input 
                        id='marca' 
                        name='marca' 
                        value={ marca } 
                        onChange={ onInputChange } 
                        placeholder='Marca' 
                        type='text'/>
                </FormGroup>
            </Col>
        </>
    )
}

export {
    FormGarantiaDetalleVehiculo
}
  